import styled from "styled-components";
import global from "../../global";

export const FilterWrapper = styled.div`
  position: relative;
  display: inline-block;
  z-index: 20;

  &.open {
    z-index: 100;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    width: 100%;
  }
`;

export const FilterButton = styled.button<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--white);
  border: 1px solid var(--fixit);
  color: var(--fixit);
  font-size: 14px;
  font-weight: 600;
  padding: 0 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  height: 38px;
  box-sizing: border-box;

  &:hover {
    background: rgba(152, 53, 209, 0.05);
  }

  svg {
    stroke-width: 2.5px;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    width: 100%;
  }
`;

export const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: var(--white);
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid rgba(0, 0, 0, 0.05);
  min-width: 380px;
  display: flex;
  flex-direction: column;
  overflow: visible;

  @media (max-width: 400px) {
    min-width: 280px;
    right: -10px;
  }
`;

export const ContentContainer = styled.div`
  padding: 20px;
  background: var(--white);
  border-radius: 12px 12px 0 0;
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  position: relative;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .radio-custom {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid var(--gray);
    display: inline-block;
    position: relative;
    transition: all 0.2s ease;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) scale(0);
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: var(--fixit);
      transition: all 0.2s ease;
    }
  }

  input:checked ~ .radio-custom {
    border-color: var(--fixit);
    &::after {
      transform: translate(-50%, -50%) scale(1);
    }
  }

  .label {
    font-size: 15px;
    color: var(--dark-gray);
    font-weight: 400;
    transition: color 0.2s ease;
  }

  input:checked ~ .label {
    color: var(--black);
    font-weight: 500;
  }

  &:hover .radio-custom {
    border-color: var(--fixit);
  }
`;

export const CustomDateContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 8px;
  margin-left: 32px; /* Indent to align with text */
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;

  .separator {
    color: var(--gray);
    font-size: 14px;
  }

  @media (max-width: ${global.responsive.small.width.value}${global.responsive.small.width.unit}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-left: 0;
  }
`;

export const DateInputWrapper = styled.div`
  display: flex;
  align-items: center;
  background: var(--white);
  border: 1px solid var(--light-gray);
  border-radius: 6px;
  padding: 8px 12px;
  width: 140px;

  .react-datepicker-popper {
    z-index: 100 !important;
  }

  svg {
    color: var(--gray);
    margin-left: auto;
  }

  .react-datepicker-wrapper {
    width: 100%;

    input {
      width: 100%;
      font-size: 14px;
      font-weight: 500;
      color: var(--dark-gray);
      background: transparent;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 20px;
  background: var(--background);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  gap: 12px;
  border-radius: 0 0 12px 12px;
`;
